export default {
	GET_ESS_REPORT: "EssReporting/GetEssReport",
	GET_LATEST_ESS_READINGS: "EssReporting/GetLatestEssReadings",

	MQTT_PUBLISH: "Mqtt/Publish",

	COMMAND_PROXY_SCHEDULE: "CommandProxyTask/Schedule",
	COMMAND_PROXY_SCHEDULE_TEST: "CommandProxyTask/ScheduleTest",
	COMMAND_PROXY_LITERAL_ACTION: "CommandProxyTask/ScheduleLiteral",
	RSU_CONFIG_1218_LITERAL_ACTION: "DeviceRsuConfig/ScheduleLiteral",

	VALIDATE_TIM: "CVMessages/GenerateTIMPayload",

	UPDATE_DEPLOYMENT_INFO: "DeviceMeta/UpdateDeviceDeploymentInfo",
	UPDATE_DEVICECHECK_INFO: "DeviceMeta/UpdateDeviceCheckInfo",
	UPDATE_SUPPORT_CONTACT_INFO: "DeviceMeta/UpdateSupportContactInfo",

	GET_DEVICES_STATUSES: "DeviceMeta/GetDeviceStatuses",
	GET_TOTALSTATION_HISTORY: "DeviceMeta/GetTotalStationStatusHistory",
	GET_DEVICE_HISTORY: "DeviceMeta/GetDeviceStatusHistory",
	GET_DEVICE_NEAR_NEIGHBOR_INFO: "DeviceMeta/GetDeviceNearNeighborInfo",
	GET_ESS_OPERATIONAL_DATA: "DeviceMeta/GetESSOpsData",
	GET_RSU_DEVICES: "DeviceMeta/GetRSUs",
	GET_ESS_DEVICES: "DeviceMeta/GetESSs",
	GET_RSU_BY_USER: "DeviceMeta/GetRSUsByUserId",
	GET_TSC_BY_USER: "DeviceMeta/GetTSCsByUserId",
	GET_ESS_BY_USER: "DeviceMeta/GetESSsByUserId",
	GET_RSU_DSRC_BY_USER: "DeviceMeta/GetRSUDSRCsByUserId",
	GET_RSU_RADIO_NEIGHBORS_BY_USER: "TfmVerification/RSURadioNeighbors",
	GET_MESSAGES_BROADCAST_BY_DEVICE: "DeviceMeta/GetMessagesBroadcastByDevice",
	GET_RSU_REGION_AND_INTERSECTION: "DeviceMeta/GetRSURegionAndIntersection",
	GET_TOTAL_STATIONS: "DeviceMeta/GetTotalStations",
	GET_TOTAL_STATIONS_DEVICES: "DeviceMeta/GetTotalStationsDevices",
	GET_DEVICE_TYPES: "DeviceMeta/GetDeviceTypes",
	GET_ACTIVE_TIMS_BY_DEVICE_ID: "DeviceMeta/SelectActiveTIMsByDeviceId",
	GET_CLIENT_BY_USER_LIST: "DeviceMeta/GetClientByUserList",
	GET_CREDENTIAL_TYPE_LIST: "DeviceMeta/GetCredentialTypeList",
	SELECT_LIKELY_INTERSECTION_CANDIDATES_BY_DEVICE_ID:
		"CVMessages/SelectLikelyIntersectionCandidatesByDeviceId",
	SELECT_INTERSECTION_BY_INTERSECTION_ID:
		"CVMessages/SelectIntersectionByIntersectionId",
	SELECT_VU_APPROACH_LOCATION_BY_VU_APPROACH_LOCATION_ID:
		"CVMessages/SelectVUApproachLocationByVUApproachLocationId",

	GET_IP_ADDRESS_BY_DEVICE_ID: "DeviceMeta/GetIpAddressByDeviceId",

	GET_RSU_MANAGE_INFO: "DeviceMeta/GetRSUManageInfo",
	GET_TSC_MANAGE_INFO: "DeviceMeta/GetTSCManageInfo",
	GET_ESS_MANAGE_INFO: "DeviceMeta/GetESSManageInfo",
	GET_TOTALSTATION_MANAGE_INFO: "DeviceMeta/GetTotalStationManageInfo",

	GET_TIM_CONTENT_TYPE_LIST: "CVMessages/GetTIMContentTypeList",
	GET_TIM_FRAME_TYPE_LIST: "CVMessages/GetTIMFRAMETypeList",
	GET_TIM_AREA_TYPE_LIST: "CVMessages/GetTIMAreaTypeList",
	GET_ITIS_CODE_LIST: "CVMessages/GetItisCodeList",
	GET_ROAD_SURFACE_DESCRIPTIONS: "CVMessages/GetRoadSurfaceDescriptions",

	GET_ALL_TIMS_AND_METADATA_BY_DEVICE_ID:
		"CVMessages/GetAllTIMsAndMetadataByDeviceId",
	GET_TIM_WITH_METADATA: "CVMessages/GetTIMWithMetadata",

	GET_RWM_LIST_BY_DEVICE_ID: "CVMessages/GetRwmListByDeviceId",
	GET_RWM_BY_ID: "CVMessages/GetRwmById",
	INSERT_RWM: "CVMessages/InsertRwm",
	UPDATE_RWM: "CVMessages/UpdateRwm",
	DELETE_RWM: "CVMessages/DeleteRwm",
	VALIDATE_RWM: "CVMessages/GenerateRwmPayload",

	DELETE_RSU_TIM: "CVMessages/DeleteTIMById",
	DELETE_TEST_TIMS: "CVMessages/DeleteTestTIMsByDeviceId",

	POST_TIM_WITH_METADATA: "CVMessages/InsertTIMWithMetadata",
	UPDATE_TIM_WITH_METADATA: "CVMessages/UpdateTIMWithMetadata",

	GET_VALIDATED_TIMS_BY_DEVICE_ID: "CVMessages/GetValidatedTIMListByDeviceId",
	GET_MAP_PAYLOAD_BY_DEVICE_ID: "CVMessages/GetMAPPayloadByDeviceId",

	// Profile controller
	INSERT_PROFILE_ATTRIBUTE: "Profile/InsertAppuserProfileAttribute",
	GET_PROFILE_ATTRIBUTE: "Profile/GetProfileAttribute",
	CREATE_NEW_USER_REQUEST: "Profile/CreateNewUserRequest",

	GENERATE_PASSWORD_RESET_TOKEN_EMAIL:
		"Account/GeneratePasswordResetTokenEmail",
	RESET_PASSWORD: "Account/ResetPassword",
	CHECK_PASSWORD_COMPROMISED: "Account/IsPasswordCompromised",
	CHECK_PASSWORD_RESET_TOKEN_EXPIRATION:
		"Account/CheckPasswordResetTokenExpiration",
	CONTACT_US_QUERY: "Account/ContactUsQuery",

	// Intersections controller
	GET_LANES_BY_INTERSECTION_ID: "Intersections/LanesByIntersectionId",
	GET_LANES_BY_RSU_ID: "Intersections/LaneDataByRsuId",
	GET_LANE_TYPE_ATTRIBUTE_LIST: "Intersections/LaneTypeAttributeList",
	GET_LANE_SHARING_LIST: "Intersections/LaneSharingList",
	UPDATE_LANE_IS_ENABLED: "Intersections/UpdateLaneIsEnabled",
	UPDATE_LANE_MANEUVERS: "Intersections/UpdateLaneManeuvers",
	UPDATE_LANE_CONNECT_TOS: "Intersections/UpdateLaneConnectTos",
	UPDATE_TOGGLED_LANE_NODES: "Intersections/UpdateToggledLaneNodes",
	UPDATE_LANE_TYPE: "Intersections/UpdateLaneType",
	UPDATE_LANE_SHARINGS: "Intersections/UpdateLaneSharings",
	REDUCE_LANE_NODES: "Intersections/ReduceLaneNodes",
	ENABLE_ALL_LANE_NODES_BY_INTERSECTION_ID:
		"Intersections/EnableAllLaneNodesByIntersectionId",
	GET_INTERSECTION_SUMMARY_LIST_BY_INTERSECTION_ID:
		"Intersections/IntersectionSummaryListByIntersectionId",
	UPDATE_RSU_INTERSECTION: "DeviceMeta/UpdateRSUSetIntersectionId",
	UPDATE_INTERSECTION_MAP_INTERSECTION_ID:
		"CVMessages/UpdateIntersectionSetRSUIntersectionId",

	// MapMessages controller
	GET_MAP_MESSAGE_BY_INTERSECTION_ID: "MapMessages/ByIntersectionId",
	GET_MAP_MANEUVER_LIST: "MapMessages/ManeuverList",
	GET_MAP_LANE_TYPE_LIST: "MapMessages/LaneTypeList",
	GENERATE_MAP_PAYLOAD: "MapMessages/Generate",
	GET_MAP_DATA_VALIDATION: "MapMessages/MapDataValidation",
	UPDATE_LANE_NODE_OFFSETS: "MapMessages/UpdateLaneNodeOffsets",

	// RSURequest/DeviceInfo controller
	GET_MODEL_LIST: "DeviceInfo/GetModelList",
	GET_LOCATION_TYPE_LIST: "DeviceInfo/GetLocationTypeList",
	GET_IP_ADDRESS_TYPE_LIST: "DeviceInfo/GetIpAddressTypeList",
	GET_MAC_ADDRESS_TYPE_LIST: "DeviceInfo/GetMacAddressTypeList",
	GET_AUTH_TYPE_LIST: "DeviceInfo/GetAuthTypeList",
	GET_PRIVILEGE_TYPE_LIST: "DeviceInfo/GetPrivilegeTypeList",
	GET_DEVICE_TENANT_LIST: "DeviceInfo/GetDeviceTenantList",
	GET_TEST_LABS: "DeviceInfo/GetTestLabs",
	GET_VUS_NEAREST_LAB: "DeviceMeta/SelectVUNearestLatLong",
	GET_PORT_TYPES: "DeviceMeta/SelectPortTypesByDeviceType",
	GET_TENANT_LIST: "DeviceMeta/GetTenantList",
	GET_APP_TYPE_LIST: "DeviceInfo/GetAppTypeList",
	GET_MOVEMENTS_BY_INTERSECTION_ID: "DeviceInfo/GetMovementsByIntersectionId",

	// TfmVerification controller
	GET_RSUS_NEAR_VUNIT_BY_USER: "TfmVerification/RSUsNearVUnit",
	GET_VUNITS_WITH_LATEST_LOCATION: "TfmVerification/VUnitsWithLatestLocation",
	GET_VUAPPROACHES_BY_INTERSECTION_ID:
		"TfmVerification/ApproachesByIntersectionId",
	GET_VUAPPROACHES_BY_RSU_ID: "TfmVerification/ApproachesByRSUId",
	GET_VUAPPROACHES_BY_VU_APPROACH_LOCATION_ID:
		"TfmVerification/ApproachesByVUApproachLocationId",
	GET_REPLAY_DATA_BY_TESTSETNUM: "TfmVerification/TestReplayDataByTestsetnum",
	GET_REPLAY_HEADERS_BY_TESTSETNUM:
		"TfmVerification/TestReplayHeaderDataByTestsetnum",
	GET_REPLAY_PPDATA_BY_TESTSETNUM:
		"TfmVerification/TestReplayPPDataByTestsetnum",
	GET_APPROACH_RUN_TEST_RESULTS:
		"TfmVerification/ApproachRunTestResultsByApproachRunId",
	GET_APPROACH_TEST_RESULTS:
		"TfmVerification/ApproachRunTestResultsByApproachTestId",
	GET_APPROACH_RUN_DEFAULT_TEST_RESULTS:
		"TfmVerification/ApproachRunTestResultsDefaultByApproachRunId",
	GET_MESSAGE_COUNTS_BY_APPROACH_DISTANCE:
		"TfmVerification/MessageTypeCountsByApproachDistance",
	GENERATE_VU_FINAL_TEST: "TfmVerification/GenerateVUFinalTest",
	GET_SPAT_TRANSITIONS_FROM_TEST: "TfmVerification/SPaTtransitionsFromTest",
	REGISTER_DEVICE_SELECTION: "TfmVerification/RegisterDeviceSelection",
	RECENT_APPROACH_RUNS_BY_VUNIT: "TfmVerification/RecentApproachRunsByVUnit",
	GET_RSU_LIST_WITH_COMPLETE_TEST:
		"TfmVerification/SelectRSUListWithCompleteTest",
	GET_TEST_LIST_BY_RSU: "TfmVerification/SelectRsuAtpTestResults",
	APPROACH_RUNS_BY_TESTSETNUM: "TfmVerification/VUApproachRunsByTestsetnum",
	GET_ROAD_SEGS_FOR_APPROACH_CREATION:
		"TfmVerification/RoadSegmentsForVUApproachCreation",
	GET_TEST_CONFIG_BY_TESTSETNUM: "TfmVerification/VUTestConfigByTestsetnum",

	// DeviceSCR controller
	POST_RSU_SCR: "DeviceSCR/CreateRsuScr",
	UPDATE_RSU_SCR: "DeviceSCR/UpdateRsuScr",
	CREATE_TOTAL_STATION_SCR: "DeviceSCR/CreateTsScr",
	MODIFY_TOTAL_STATION_SCR: "DeviceSCR/InsertTsScrModifiedChanges",
	MODIFY_RSU_SCR: "DeviceSCR/ModifyRsuScr",
	MODIFY_ESS_SCR: "DeviceSCR/ModifyEssScr",
	MODIFY_TSC_SCR: "DeviceSCR/ModifyTscScr",
	UPDATE_TOTAL_STATION_SCR: "DeviceSCR/UpdateTsScr",
	GET_PENDING_SCRS_BY_USER: "DeviceSCR/GetPendingScrsByUser",
	GET_RSU_SCR_BY_DEVICE_SCR_ID: "DeviceSCR/GetRsuScrByDeviceScrId",
	GET_TOTALSTATION_SCR_BY_SCR_ID: "DeviceSCR/GetTotalStationSScrByScrId",
	APPROVE_DEVICE_SCR: "DeviceSCR/ApproveDeviceSCR",
	APPROVE_TOTALSTATION_SCR: "DeviceSCR/ApproveTsScr",
	APPROVE_TOTALSTATION_MODIFIED_SCR: "DeviceSCR/ApproveTsModifiedScr",
	REJECT_TOTALSTATION_MODIFIED_SCR: "DeviceSCR/RejectTsModifiedScr",
	APPROVE_DEVICE_MODIFIED_SCR: "DeviceSCR/ApproveDeviceModifiedScr",
	REJECT_DEVICE_MODIFIED_SCR: "DeviceSCR/RejectDeviceModifiedScr",
	REJECT_DEVICE_SCR: "DeviceSCR/RejectDeviceSCR",
	REJECT_TOTALSTATION_SCR: "DeviceSCR/RejectTsScr",
	DELETE_TOTALSTATION_SCR: "DeviceSCR/DeleteTsScr",
	DELETE_DEVICE_SCR: "DeviceSCR/DeleteDeviceSCR",
	POST_TSC_SCR: "DeviceSCR/CreateTscScr",
	UPDATE_TSC_SCR: "DeviceSCR/UpdateTscScr",
	GET_TSC_SCR_BY_DEVICE_SCR_ID: "DeviceSCR/GetTscScrByDeviceScrId",
	GET_TOTAL_STATION_BY_DEFINED_AREA: "DeviceSCR/GetTotalStationByDefinedArea",
	GET_APPROACHES_BY_DEVICE_SCR_ID: "DeviceSCR/GetApproachesByDeviceScrId",
	GET_STATION_TYPES_LIST: "DeviceInfo/GetStationTypesList",
	GET_ESS_EXTERNALFLAG_LIST: "DeviceInfo/GetESSExternalFlagList",
	GET_STATION_CATEGORY_LIST: "DeviceInfo/GetStationCategoryList",
	GET_REGION_DISTRICT_LIST: "DeviceMeta/GetRegionDistrictList",
	GET_ESS_SENSOR_LIST: "DeviceInfo/GetESSsensorList",
	GET_ESS_SCR_BY_DEVICE_SCR_ID: "DeviceSCR/GetEssScrByDeviceScrId",
	UPDATE_ESS_SCR: "DeviceSCR/UpdateEssScr",
	POST_ESS_SCR: "DeviceSCR/CreateEssScr",
	GET_HISTORICAL_TESTS: "DeviceSCR/GetRSULabTestsByDeviceSCRId",
	GET_NETWORKS_BY_SCR: "DeviceSCR/GetNetworkByDeviceSCRId",
	SAVE_LAB_TEST_RESULTS: "DeviceSCR/SaveRSULabTestByDeviceSCRId",
	CHECK_IP_PORT_VALID: "DeviceSCR/CheckIPPortValidity",

	// User controller
	GET_PENDING_USER_REQUESTS: "User/GetPendingUserRequests",
	GET_FACILITY_LIST: "User/GetFacilityList",
	GET_FUNCTIONAL_AREA_LIST: "User/GetFunctionalAreaList",
	GET_JOB_ROLE_LIST: "User/GetJobRoleList",
	REQUEST_USER: "User/RequestUser",
	APPROVE_USER_REQUEST: "User/ApproveUserRequest",
	DECLINE_USER_REQUEST: "User/DeclineUserRequest",
	GET_JOB_ROLE_LIST_ALLOWED: "User/GetJobRoleListAllowed",
	UPDATE_USER_REQUEST: "User/UpdateUserRequest",

	// Account controller
	GET_PERSON_LIST: "Account/PersonList",
	GET_USER_INFO: "Account/Info",
	GET_USER_EMAILINFO: "Account/EmailInfo",

	// Dashboard controller
	GET_STATUS_TS: "Dashboard/Status/TotalStations",
	GET_STATUS_RSU: "Dashboard/Status/Devices/Rsu",
	GET_STATUS_TSC: "Dashboard/Status/Devices/Tsc",
	GET_STATUS_ESS: "Dashboard/Status/Devices/Ess",
	UNVERIFIED_HEADINGS: "Dashboard/DmsTim/UnverifiedHeadings",

	// MOT controller
	CREATE_NEW_TFLOW_PROJECT: "TFlow/CreateNewTFlowProject",
	UPDATE_TFLOW_PROJECT: "TFlow/UpdateTFlowProject",
	EDIT_MOT_REQUEST: "MOT/EditMOTRequest",
	CREATE_NEW_MOT_REQUEST: "MOT/CreateNewMOTRequest",
	GET_NAVIGATION_BYCLIENT: "MOT/NavigationLevelsByClientId",
	GET_SECTION_TEXT: "MOT/GetSectionByNavigationId",
	GET_MOT_CLIENTS: "MOT/GetMOTClients",
	GET_CONTRACTORS: "MOT/GetContractors",
	GET_INFRASTRUCTURE_OWNERS: "MOT/GetInfrastructureOwners",
	GET_COUNTIES: "MOT/GetCounties",
	GET_MOT_ROUTES: "MOT/GetMOTRoutes",
	GET_ALL_TYPICALS: "MOT/GetTypicals",
	GET_MOT_HOLIDAYS: "MOT/GetMOTHolidays",
	GET_MOT_SPECIALEVENTS: "MOT/GetMOTSpecialEvents",
	GET_ALL_CITY: "MOT/GetAllCity",
	GET_ALL_TOWNSHIP: "MOT/GetAllTownshipByMOT",
	GET_TOWNSHIP_BYMOT: "MOT/GetAllTownshipByMOT",
	GET_MOT_DISTRICTS: "MOT/GetMOTDistricts",
	GET_FLEET_TRACKER_VEHICLES: "FleetManagement/RetrieveFleetManagementVehicles",
	GET_MOT_PROJECTS: "TFlow/RetrieveTFlowProjects",
	GET_MOT_DIRECTION: "MOT/GetMOTDirections",
	GET_MOT_TIMEFRAME: "MOT/GetMOTTimeframe",
	GET_MOT_CLOSURES: "MOT/GetMOTClosures",
	GET_MOT_TYPICALS: "MOT/GetMOTTRTypical",
	GET_MOT_REQUESTS_BY_USER: "MOT/GetMOTRequestsByUser",
	GET_RAMP_OPERATION: "MOT/GetRampOperations",
	GET_UNIT_MEASURES: "MOT/GetUnitOfMeasures",
	GET_UNIT_TIME: "MOT/GetUnitOfTime",
	GET_WORK_OPERATION: "MOT/GetWorkOperations",
	GET_JOB_DISTRICTS: "MOT/GetJobDistricts",
	GET_JOB_REGION: "MOT/GetJobRegion",
	GET_JOB_SUB: "MOT/GetJobSub",
	GET_TS_OPS: "MOT/GetMOTTSOps",
	GET_MSG_TIMEFRAMES: "MOT/GetMsgTimeframes",
	GET_MOT_CITY: "MOT/GetMOTCity",
	GET_ALL_VARIABLE_VALUE: "MOT/GetMOTVariableValue",
	GET_ALL_VARIABLES: "MOT/GetMOTVariables",
	GET_MOT_CONSTRUCTION_STAGES: "MOT/GetMOTConstructionStages",
	GET_MOT_COUNTY: "MOT/GetMOTCounty",
	GET_ROUTE_NAME: "MOT/GetRouteName",
	GET_MOT_RAMP: "MOT/GetMOTRampClosures",
	GET_MOT_TRO_TYPICAL: "MOT/GetMOTROTypical",
	GET_MOTITCPRestrictedTime: "MOT/GetMOTITCPResTime",
	GET_MOT_LANE_RESTRICTIONS: "MOT/GetMOTLaneRestriction",
	GET_MOT_NIGHT_WORK: "MOT/GetMOTNightWork",
	GET_MOT_PCMS_MSG: "MOT/GetMOTPCMSMsg",
	GET_MOT_TRAFFIC_REG: "MOT/GetMOTTrafficReg",
	GET_MOT_TS_OPS: "MOT/GetMOTTSOperations",
	GET_MOT_VAR_VALUE: "MOT/GetMOTVarValue",
	GET_MOT_LR_CONDITION: "MOT/GetMOTLRCondition",
	GET_MOT_UNIQUE_REQUIREMENT: "MOT/GetMOTUniqueRequirement",
	GET_MOT_MOTWZ_SL: "MOT/GetMOTWZSpeedLimit",

	//TFR Project
	GET_PROJECT_REGIONS: "MOT/GetProjectRegions",
	GET_PROJECT_TYPES: "TFlow/RetrieveTFlowProjectTypes",
	GET_PROJECT_REFERENCE_ITEMS: "TFlow/RetrieveTFlowProjectReferenceItems",

	//MOT INSERT API CALLS
	UPDATE_MOT_VARIABLE: "MOT/UpdateMOTVariable",
	UPDATE_MOT_PCMS_MESSAGE: "MOT/UpdatePCMSMessage",
	UPDATE_MOT_RAMP_CLOSURE: "MOT/UpdateRampClosure",
	UPDATE_MOT_RESTRICTION: "MOT/UpdateLaneRestriction",
	UPDATE_MOT_LR_STOPPAGE: "MOT/UpdateLRStoppage",
	UPDATE_MOT_APPROVAL: "MOT/UpdateMOTApproval",
	UPDATE_MOT_SECTION_VALIDATION: "MOT/UpdateSectionValidation",

	//MOT delete API calls
	DELETE_MOT_JOB_COUNTY: "MOT/DeleteJobCounty",
	DELETE_MOT_REQUEST: "MOT/DeleteMOTRequest",
	DELETE_TFLOW_PROJECT: "TFlow/DeleteTFlowProject",

	//Worker presence APIs
	GET_WP_HISTORY: "WP/GetWPHistory",
	GET_WP_CLOSURES: "WP/GetWPClosure",
	UPDATE_WP_INFO: "WP/UpdateWPInfo",

	//FloodDss API
	GET_FLOOD_LIKELIHOOD: "Weather/GetFloodLikelihood",
	GET_WEATHERSTATIONS_BY_AREA: "Weather/GetWxStationsWithReadingsByArea",
	GET_STREAMGAGES_BY_AREA: "StreamGage/GetStreamGagesByArea"
};
